import classNames from 'classnames';
import styles from './full-price.module.scss';

type TpFullPriceProps = {
  withDiscount?: boolean;
  price: number;
  currencySymbol: string;
};

export const FullPrice = (props: TpFullPriceProps) => {
  const { withDiscount, currencySymbol, price } = props;

  return (
    <span
      className={classNames({
        [styles.lineThrough]: !withDiscount,
      })}
    >{`${currencySymbol}${price}`}</span>
  );
};
